import { useAtom } from "jotai";
import {
  organizationsDialogAtom,
  organizationsCurrentRowAtom,
} from "../store/organizations-atom";
import { OrganizationsDeleteAllDialog } from "./organizations-delete-all-dialog";
import { OrganizationsDeleteDialog } from "./organizations-delete-dialog";

export function OrganizationsDialogs() {
  const [open, setOpen] = useAtom(organizationsDialogAtom);
  const [currentRow, setCurrentRow] = useAtom(organizationsCurrentRowAtom);

  return (
    <>
      {currentRow && (
        <OrganizationsDeleteDialog
          key={`organization-delete-${currentRow.id}`}
          open={open === "delete"}
          onOpenChange={() => {
            setOpen(open === "delete" ? null : "delete");
            setTimeout(() => setCurrentRow(null), 500);
          }}
          currentRow={currentRow}
        />
      )}

      <OrganizationsDeleteAllDialog
        key="organization-delete-all"
        open={open === "delete_all"}
        onOpenChange={() =>
          setOpen(open === "delete_all" ? null : "delete_all")
        }
      />
    </>
  );
}
